import { invoke } from '@shared/easyfy.decorators';
import SliderHelper from '@clientShared/sliderHelper';

@invoke
export class ArticleListComponent {
  static Instance: ArticleListComponent;

  onInit() {
    document.querySelectorAll('[data-container="articlelist-scroll"]').forEach((list) => {
      if (!(list instanceof HTMLElement)) return;
      list.classList.add('splide');

      const result = SliderHelper.CreateArticleSlider(list);
      if (!result) {
        return;
      }
      const { slider, excludePagination } = result;

      slider.on('mounted', () => {
        list.classList.add('slider-has-mounted');
      });

      SliderHelper.OnPaginationMounted(slider, list, excludePagination);

      SliderHelper.MountSlider(slider);

      SliderHelper.AddSliderOverlay(list);
      SliderHelper.UpdateImagesSize(slider, list);
      SliderHelper.removeDuplicatedLinks(slider);
    });
  }
}
